<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import settingsKeys from '../../../settings/settingsKeys.js';
    import { settingsGroupKeys } from '../pluginConfig.js';
    import Details from './generic/Details.svelte';
    import CheckMark from '../controls/generic/CheckMark.svelte';
    import ContrastThemeSetting from '../controls/ContrastThemeSetting.svelte';
    import { getIsNonDefaultState } from '../util.js';
    import { Icon } from '@oat-sa-private/ui-elements';
    import { __ } from '@oat-sa-private/ui-core';

    /**
     * Component of an a11y menu panel group
     */

    const groupKey = settingsGroupKeys.contrast;

    /**
     * @typedef {Object} Props
     * @property {Object} areaBroker
     * @property {Object} pluginConfig
     * @property {Object} initialSettingsState
     * @property {Function} onChange
     * @property {Function} onToggle
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        areaBroker,
        pluginConfig,
        initialSettingsState,
        onChange,
        onToggle
    } = $props();

    let nonDefault = $derived(getIsNonDefaultState(settingsKeys.contrastTheme, initialSettingsState, pluginConfig));

    function handleChange(newState) {
        nonDefault = newState.state?.nonDefault;
        onChange?.(newState);
    }
</script>

<Details
    key={groupKey}
    config={pluginConfig[groupKey]}
    collapsed={initialSettingsState[groupKey]?.collapsed}
    outlined={nonDefault}
    ariaLabelCollapse={__('collapse contrast settings')}
    ariaLabelExpand={__('expand contrast settings')}
    {onToggle}>
    {#snippet summary()}
        <h3 class="ui-heading">
            <Icon name="contrast-16" ariaHidden />
            {__('Contrast')}
            {#if nonDefault}
                <CheckMark />
            {/if}
        </h3>
    {/snippet}
    {#if pluginConfig[settingsKeys.contrastTheme]?.enabled}
        <ul>
            <li>
                <ContrastThemeSetting
                    {areaBroker}
                    config={pluginConfig[settingsKeys.contrastTheme]}
                    initialState={initialSettingsState[settingsKeys.contrastTheme]?.toolState}
                    onChange={handleChange} />
            </li>
        </ul>
    {/if}
</Details>
